import { render } from "./PageMain.vue?vue&type=template&id=3ebc1c8b"
import script from "./PageMain.vue?vue&type=script&lang=js"
export * from "./PageMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__